import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "hooks";
import {
  Page,
  List,
  Text,
  InlineStack,
  BlockStack,
  Layout,
  Card,
} from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { fetchReservations } from "./reservations.slice";
import Loading from "components/loading/Loading";

function Reservations() {
  const dispatch = useAppDispatch();
  const { companyId } = useParams();
  const { t } = useTranslation();

  const {
    reservationsReducer: { reservationsCollection, isLoading },
  } = useAppSelector((state) => state);

  useEffect(() => {
    dispatch(fetchReservations(companyId));
  }, [dispatch, companyId]);

  const nodes = reservationsCollection.map(
    (
      { title, description, items = [], dueDate, user, customer, meta, id },
      index
    ) => {
      const itemsNode = items.map(({ quantity, product = {} }, itemIndex) => (
        <List.Item key={`${product.sku || itemIndex}`}>
          [{product.sku || "N/A"}] {product.title || "—"} - {quantity}
        </List.Item>
      ));

      const userName = user?.name || user?.externalCode || "—";

      return (
        <Card roundedAbove="sm" key={id || index}>
          <BlockStack gap="">
            <BlockStack gap="200">
              <Text as="h2" variant="headingSm">
                {title || "—"}
              </Text>
              {description && (
                <Text as="p" variant="bodyMd">
                  {description}
                </Text>
              )}
              {itemsNode.length > 0 && <List type="number">{itemsNode}</List>}
              <div>{userName}</div>
            </BlockStack>
            <InlineStack align="end"></InlineStack>
          </BlockStack>
        </Card>
      );
    }
  );

  return (
    <Layout>
      <Layout.Section>
        <Page fullWidth title={t("reservations")}>
          {isLoading && <Loading />}
          {!isLoading && <BlockStack gap="500">{nodes}</BlockStack>}
        </Page>
      </Layout.Section>
      {/* {productId && (
        <Modal open titleHidden large onClose={handleProductClose}>
          <Modal.Section>
            <Outlet />
          </Modal.Section>
        </Modal>
      )} */}
    </Layout>
  );
}

export default Reservations;
